/**
 * Gestion des consentements pour tag analytique personnalisé
 */
export function gtmCustomEventByVendor(vendorId, eventObjToPush) {
  window.dataLayer = window.dataLayer || [];
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function (Didomi) {
    const consentStatus = Didomi.getUserStatus().vendors.global_consent.enabled.includes(vendorId);
    const vendorsWithKnownConsentStatus = Object.values(
      Didomi.getUserStatus().vendors.global_consent
    ).flat();
    if (consentStatus === true) {
      window.dataLayer.push(eventObjToPush);
    } else if (!vendorsWithKnownConsentStatus.includes(vendorId)) {
      Didomi.on('consent.changed', function () {
        if (Didomi.getUserStatus().vendors.global_consent.enabled.includes(vendorId) === true) {
          window.dataLayer.push(eventObjToPush);
        }
      });
    }
  });
}

/**
 * Gestion des consentements pour les préférences et s'il y lieu les autres services JEL
 */
export function userConsentObservation(vendorId, agreefct) {
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function (Didomi) {
    if (Didomi.getUserStatus().vendors.global_consent.enabled.includes(vendorId) === true) {
      agreefct();
    } else {
      console.log('Consentement inconnu pour le vendeur: ', vendorId);
    }
  });
}

export function registerVendorListenerConsent(vendorId, agreefct, desAgreefct) {
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function (Didomi) {
    Didomi.getObservableOnUserConsentStatusForVendor(vendorId).subscribe(function (consentStatus) {
      if (consentStatus === true) {
        agreefct();
      } else {
        desAgreefct();
      }
    });
  });
}

/**
 * Gestion des consentements pour Youtube
 */
export function handleYoutubeConsent() {
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function (Didomi) {
    Didomi.getObservableOnUserConsentStatusForVendor(process.env.VUE_APP_IAB_ID_YOUTUBE).subscribe(
      function (consentStatus) {
        if (consentStatus === true) {
          playVideoAndHideOverlay();
        } else {
          hidePlayerVideo();
        }
      }
    );
    document.querySelectorAll('.video-consent-overlay-accept-button').forEach(function (button) {
      button.addEventListener('click', function () {
        _setPositiveConsentStatusForVendor(process.env.VUE_APP_IAB_ID_YOUTUBE);
      });
    });
  });
}

function playVideoAndHideOverlay() {
  document.querySelectorAll('.youtube-container').forEach(function (overlay) {
    const iframe = overlay.querySelector('iframe[data-src]');
    if (iframe) {
      const src = iframe.getAttribute('data-src');
      iframe.setAttribute('src', src);
      overlay.querySelector('.video-consent-overlay').style.display = 'none';
    }
  });
}

function hidePlayerVideo() {
  document.querySelectorAll('.youtube-container').forEach(function (overlay) {
    const iframe = overlay.querySelector('iframe[src]');
    if (iframe) {
      const src = iframe.getAttribute('src');
      iframe.setAttribute('data-src', src);
      overlay.querySelector('.video-consent-overlay').style.display = 'block';
    }
  });
}

function _setPositiveConsentStatusForVendor(vendorId) {
  const purposes = window.Didomi.getVendorById(vendorId).purposeIds;
  const transaction = window.Didomi.openTransaction();
  transaction.enableVendor(vendorId);
  transaction.enablePurposes(...purposes);
  transaction.commit();
}
